import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Cases from '@/views/Cases'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/cases',
      name: 'Cases',
      component: Cases
    },
    {
      path: '/:uri+',
      name: 'Subpage',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js